module.exports = __webpack_public_path__ + "img/72.9.TU.2e13402e.png";